import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const ReloadWarning = ({ onStay, onLeave, isOpen }) => {
  return (
    <div className={`fixed inset-0 bg-slate-900 bg-opacity-60 flex justify-center items-center z-50 transition-all duration-300 ease-in-out ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      <div className={`bg-white rounded-xl shadow-2xl p-8 max-w-sm w-full text-center mx-4 transition-all duration-300 ease-in-out ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <FiAlertTriangle className="w-10 h-10 text-yellow-500" />
        </div>
        <h2 className="text-2xl font-bold text-slate-800 mb-2">Are you sure?</h2>
        <p className="text-slate-500 mb-8">
            You're about to leave the election form. Any data you have entered will be lost.
        </p>
        <div className="flex justify-center gap-4">
          <button 
            className="w-full bg-slate-600 hover:bg-slate-700 text-white font-bold py-3 px-4 rounded-lg transition-colors" 
            onClick={onStay}>
            Stay on Page
          </button>
          <button 
            className="w-full bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-4 rounded-lg transition-colors" 
            onClick={onLeave}>
            Leave Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReloadWarning;